import { render, staticRenderFns } from "./PigeonWidget.vue?vue&type=template&id=143a730a&scoped=true"
import script from "./PigeonWidget.vue?vue&type=script&lang=js"
export * from "./PigeonWidget.vue?vue&type=script&lang=js"
import style0 from "./PigeonWidget.vue?vue&type=style&index=0&id=143a730a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a730a",
  null
  
)

export default component.exports